// Import Rapid 7 from library
import R7Insight from 'r7insight_js';

import Vue from 'vue';

// Importing config file to use Rapid 7 env
import config from '../config';

// Initailise Rapid 7 with token and region
R7Insight.init({
  token: config.rapid7Token,
  region: 'eu'
});

// Create a Rapid 7 Vue Instance
let rapid7 = new Vue({
  // Methods to be used globally
  methods: {
    log(event) {
      R7Insight.log(JSON.stringify(event));
    }
  }
});

// Add a plugin to Vue Prototype
// To be accessible everywhere
// By this.$rapid7
export default {
  install: function(Vue) {
    Vue.prototype.$rapid7 = rapid7;
  }
};
